<template>
  <v-container>
    <template v-if="!playerKey">
      <v-card width="50%" class="mx-auto mt-15">
        <v-form>
          <v-text-field
            class="mx-5"
            v-model="name"
            label="Name"
            :disabled="loadingview"
          ></v-text-field>
        </v-form>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            width="100%"
            @click="addplayer"
            :disabled="loadingview"
            :loading="loadingview"
            >Join</v-btn
          >
        </v-card-actions>
      </v-card>
    </template>

    <template v-else>
      <template v-if="gameState === 'ended'">
        <GameOver :gameId="gameId" />
      </template>

      <template v-if="gameState === 'started'">
        <v-row no-gutters align="center" justify="center">
          <v-col>
            <template v-if="isCurrPlayer">
              <CurrentPlayerView :gameId="gameId" :playerKey="playerKey" />
            </template>
            <template v-else>
              <NonCurrentPlayerView
                :gameId="gameId"
                :playerKey="playerKey"
                :currentPlayer="currentPlayer"
              />
            </template>
          </v-col>
          <v-col cols="4" no-gutters>
            <template v-if="timerEndTime">
              <Timer :endTime="timerEndTime" />
            </template>
            <Players :gameId="gameId" :currentPlayer="currentPlayer" />
          </v-col>
        </v-row>
      </template>

      <template v-if="gameState === 'waiting'">
        <WaitingRoom :gameId="gameId" :playerKey="playerKey" />
      </template>

      <template v-if="gameState === 'recreating'">
        Recreating game!
      </template>
    </template>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Players from "./PlayingPlayers.vue";
import WaitingRoom from "./WaitingRoom";
import CurrentPlayerView from "./CurrentPlayerView.vue";
import NonCurrentPlayerView from "./NonCurrentPlayerView.vue";
import GameOver from "./GameOver";
import Timer from "./Timer";
import { functions } from "@/components/firebase/config";
import refs from "./firebase/refs";
import game_play from "./firebase/game_play";

export default {
  name: "ActiveIndividualGame",
  props: {
    gameId: String,
    playerKey: String,
  },
  components: {
    Players,
    WaitingRoom,
    Timer,
    CurrentPlayerView,
    NonCurrentPlayerView,
    GameOver,
  },
  created() {
    this.$once("joined", () => {
      this.listenForGameState();
      this.listenForCurrentPlayer();
      this.listenForTimer();
      this.listenForGameEnd();
    });
    if (this.playerKey) {
      this.$emit("joined");
    }
    this.$root.$once("end-turn", () => {
      console.log("removing timer");
      refs.timer(this.gameId).remove();
      this.timerEndTime = undefined;
    });
  },
  methods: {
    listenForGameState() {
      refs.state(this.gameId).on("value", (snapshot) => {
        this.gameState = snapshot.val();
      });
    },
    async addplayer() {
      console.log("clicked");
      this.loadingview = true;
      var playerInfo = await functions.httpsCallable("addPlayer")({
        gameId: this.gameId,
        player: this.name,
      });
      console.log("playerInfo", playerInfo);
      this.playerKey = playerInfo.data.playerKey;
      this.$emit("joined");
    },
    listenForCurrentPlayer() {
      refs.currentPlayer(this.gameId).on("value", (snapshot) => {
        this.currentPlayer = snapshot.val();
        this.isCurrPlayer = this.currentPlayer.playerKey === this.playerKey;
        this.shouldSeeCard = game_play.shouldSeeCard(
          this.playerKey,
          this.currentPlayer
        );
      });
    },
    listenForTimer() {
      refs.timer(this.gameId).on("value", (snapshot) => {
        if (snapshot.val()) {
          this.timerEndTime = snapshot.val();
          this.$root.$emit("start-timer");
        }
      });
    },
    listenForGameEnd() {
      refs.roundCount(this.gameId).on("value", async (snapshot) => {
        if (snapshot.val() > 1) {
          await refs.state(this.gameId).set("ended");
        }
      });
    },
  },
  data() {
    return {
      loadingview: false,
      name: "",
      gameState: "waiting",
      currentPlayer: "",
      shouldSeeCard: false,
      isCurrPlayer: true,
      timerEndTime: undefined,
    };
  },
};
</script>
